(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hip-planning-tools"] && !Shopify.designMode) return;
  try {
    
(() => {
  const ceil = (value, decimals = 0) => Math.ceil(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
  const num = (panel, name) => Number(panel.querySelector(`[data-field="${name}"]`)?.value || 0);
  const set = (panel, value) => { const result = panel.querySelector('[data-result]'); if (result) result.textContent = `${result.dataset.prefix} ${value}`; };
  const tools = {
    paint(p){ const area=Math.max(0,num(p,'width')*num(p,'height')-num(p,'deductions')); const l=num(p,'coverage')>0?ceil(area*num(p,'coats')/num(p,'coverage'),1):0; set(p,`${l.toFixed(1)}L`); },
    wallpaper(p){ const drops=Math.ceil(num(p,'width')/num(p,'rollWidth')); const dropsPerRoll=Math.max(1,Math.floor(num(p,'rollLength')/(num(p,'height')*(1+num(p,'waste')/100)))); set(p,`${Math.ceil(drops/dropsPerRoll)} rolls (${drops} drops)`); },
    panelling(p){ const uprights=(num(p,'bays')+1)*num(p,'height'); const rails=num(p,'rails')*num(p,'width'); set(p,`${ceil((uprights+rails)*(1+num(p,'waste')/100),1).toFixed(1)}m`); },
    tiles(p){ const area=num(p,'areaWidth')*num(p,'areaHeight'); const tile=(num(p,'tileWidth')/1000)*(num(p,'tileHeight')/1000); set(p,`${tile>0?Math.ceil((area/tile)*(1+num(p,'waste')/100)):0}`); },
    grout(p){ const factor=1+num(p,'waste')/100; set(p,`${ceil(num(p,'area')*num(p,'adhesiveRate')*factor,1)}kg adhesive, ${ceil(num(p,'area')*num(p,'groutRate')*factor,1)}kg grout`); },
    sealant(p){ const ml=(num(p,'length')*1000*num(p,'width')*num(p,'depth')/1000)*(1+num(p,'waste')/100); set(p,`${num(p,'size')>0?Math.ceil(ml/num(p,'size')):0}`); },
    flooring(p){ const area=num(p,'length')*num(p,'width')*(1+num(p,'waste')/100); set(p,`${num(p,'pack')>0?Math.ceil(area/num(p,'pack')):0}`); },
    fixings(p){ const load=num(p,'points')>0?ceil(num(p,'weight')*num(p,'factor')/num(p,'points'),1):0; set(p,`${load.toFixed(1)}kg`); },
    radiator(p){ const btu=num(p,'length')*num(p,'width')*num(p,'height')*num(p,'rate'); set(p,`${Math.ceil(btu)} BTU / ${Math.ceil(btu*0.293)}W`); },
    pipe(p){ const length=(num(p,'length')+(num(p,'turns')*num(p,'allowance')))*(1+num(p,'waste')/100); set(p,`${ceil(length,1).toFixed(1)}m`); },
    decking(p){ const pitch=(num(p,'board')+num(p,'gap'))/1000; set(p,`${pitch>0?Math.ceil((num(p,'width')/pitch)*(1+num(p,'waste')/100)):0}`); },
    paving(p){ const area=num(p,'length')*num(p,'width'); const slab=(num(p,'slabLength')/1000)*(num(p,'slabWidth')/1000); set(p,`${slab>0?Math.ceil((area/slab)*(1+num(p,'waste')/100)):0}`); },
    postmix(p){ const radius=num(p,'diameter')/2000; const litres=Math.PI*radius*radius*(num(p,'depth')/1000)*1000*num(p,'holes'); set(p,`${num(p,'yield')>0?Math.ceil(litres/num(p,'yield')):0}`); },
    soil(p){ const litres=num(p,'length')*num(p,'width')*(num(p,'depth')/100)*1000; set(p,`${Math.ceil(litres)}L / ${num(p,'bag')>0?Math.ceil(litres/num(p,'bag')):0} bags`); },
    mulch(p){ const litres=num(p,'area')*(num(p,'depth')/100)*1000; set(p,`${num(p,'bag')>0?Math.ceil(litres/num(p,'bag')):0} bags (${Math.ceil(litres)}L)`); },
    lawn(p){ const area=num(p,'length')*num(p,'width'); set(p,`${ceil(area*num(p,'seedRate')/1000,1)}kg seed or ${num(p,'roll')>0?Math.ceil(area/num(p,'roll')):0} turf rolls`); },
    raisedbed(p){ const total=num(p,'length')*num(p,'width')*(num(p,'depth')/100)*1000; const compost=total*num(p,'compost')/100; set(p,`${Math.ceil(total)}L total, about ${Math.ceil(compost)}L compost top layer`); },
    budget(p){ const base=num(p,'materials')+num(p,'tools')+num(p,'delivery')+num(p,'trade'); set(p,`GBP ${Math.ceil(base*(1+num(p,'contingency')/100))}`); },
    checklist(p){ const items=[...p.querySelectorAll('[data-check]:checked')].map((i)=>`• ${i.dataset.check}`); const custom=p.querySelector('[data-field="custom"]')?.value.trim(); if(custom) items.push(`• ${custom}`); set(p,items.length?items.join(' '):'Choose at least one item.'); }
  };
  document.querySelectorAll('[data-hip-tool]').forEach((panel)=>{ const update=()=>tools[panel.dataset.hipTool]?.(panel); panel.addEventListener('input',update); panel.addEventListener('change',update); update(); });
})();

  } catch(e) { console.error(e); }
})();
})();
